//
//
//
//
export default {
  name: 'ListNearbyLocations',
  components: {
    FibLocationPicker: require('@/components/LocationPicker').default
  },
  methods: {
    onLocationSelected: function onLocationSelected() {
      this.onSubmit();
    },
    onSubmit: function onSubmit() {
      // redirect to guest table number entry
      Logger.debug('location selected and submitted - redirecting to guest table number entry');
      this.$router.push('/check_in/guest_table_number_entry');
    }
  }
};